<!--
组件关联页面：数据空白时展示页面
-->
<template>
  <div class="v-empty">
    <img src="../../assets/imgs/empty.png" alt="">
    <h3 class="text">{{text}}</h3>
  </div>
</template>

<script>
export default {
  name: 'v-empty',

  components: {
  },

  filters: {
  },

  mixins: [
  ],

  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  },

  data () {
    return {
    }
  },

  created () {
  },

  mounted () {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  }

}
</script>

<style lang="less" scoped>
.v-empty {
  flex: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  img {
    width: 300px;
  }
  .text {
    margin: 20px 0;
    font-size: 15px;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// v-empty.vue?4d8d0340